import React from 'react';
import {
    S16BackgroundImage,
    S16BackgroundImageProps,
    MilanBackgroundColors,
    MilanGradientColors,
} from '@milanlaser/mlcomponents';
import { PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';
import { processBackgroundAndGradientColorMap } from '../../../../components/builder/utils/builder.utils';
import { useFirebaseMetrics } from '../../utils/useFirebaseMetrics';

type S16BackgroundImageBuilderProps = Omit<S16BackgroundImageProps, 'backgroundColor' | 'imagePosition'> & {
    desktopPaddingTop?: PaddingSize;
    desktopPaddingBottom?: PaddingSize;
    mobilePaddingTop?: PaddingSize;
    mobilePaddingBottom?: PaddingSize;
    imageAltText?: string;
    backgroundColor?: string;
    backgroundGradient?: string;
    imagePosition: boolean;
};

export function S16BackgroundImageSection(s16Props: S16BackgroundImageBuilderProps) {
    const { replaceVariables } = useFirebaseMetrics();
    const {
        desktopPaddingTop = 'none',
        desktopPaddingBottom = 'none',
        mobilePaddingTop = 'none',
        mobilePaddingBottom = 'none',
        backgroundColor,
        backgroundGradient,
        imagePosition,
        waveGradient,
        ...restProps
    } = s16Props;

    const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
    const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;

    const processedBackgroundColor = backgroundColor === 'None' ? 'White' : backgroundColor;

    const processedSubsections = restProps.subsections?.map((subsection) => ({
        ...subsection,
        heading: replaceVariables(subsection.heading),
        body: replaceVariables(subsection.body)
    })) || [];

    const modifiedProps = {
        ...restProps,
        subsections: processedSubsections,
        imagePosition: imagePosition ? 'right' as const : 'left' as const,
        backgroundGradient:
            backgroundGradient === ('None' as MilanGradientColors | 'None') ? 'default' : backgroundGradient,
        waveGradient: waveGradient === ('None' as MilanGradientColors | 'None') ? 'default' : waveGradient,
        backgroundColor: (backgroundColor === 'None' ? 'default' : backgroundColor || 'default') as MilanBackgroundColors,
        className: `mcl-mx-auto ${topPaddingClasses} ${bottomPaddingClasses}`,
    };

    const backgroundColorClass = processBackgroundAndGradientColorMap({
        backgroundColor: (processedBackgroundColor as MilanBackgroundColors) || 'None',
        gradientColor: backgroundGradient || 'None',
    });

    return (
        <div className={`${backgroundColorClass}`}>
            <S16BackgroundImage {...modifiedProps} waveGradient={waveGradient} />
        </div>
    );
}
